(() => {
  if (window.radianPromotionInitialized) return;
  window.radianPromotionInitialized = true;

  function makeDecorative(node) {
    node.setAttribute('aria-hidden', 'true');
    node.inert = true;
    Array.from(node.attributes).forEach((attribute) => {
      if (attribute.name.startsWith('data-shopify-')) node.removeAttribute(attribute.name);
    });
    if (node.matches('a')) node.tabIndex = -1;
    return node;
  }

  function init(root) {
    if (root.dataset.promotionInitialized === 'true') return;
    const viewport = root.querySelector('[data-promotion-viewport]');
    const track = root.querySelector('[data-promotion-track]');
    const group = root.querySelector('[data-promotion-group]');
    if (!viewport || !track || !group || !group.children.length) return;

    const originals = Array.from(group.children);
    const rebuild = () => {
      group.replaceChildren(...originals);
      track.replaceChildren(group);

      // Measure one set once, then append every repeat in a single batch (no read per clone).
      const setWidth = group.scrollWidth;
      const repeats = setWidth > 0 ? Math.max(0, Math.ceil((viewport.clientWidth * 1.5) / setWidth) - 1) : 0;
      const clones = document.createDocumentFragment();
      for (let index = 0; index < Math.min(repeats * originals.length, 100); index += 1) {
        clones.appendChild(makeDecorative(originals[index % originals.length].cloneNode(true)));
      }
      group.appendChild(clones);

      const copy = group.cloneNode(true);
      copy.removeAttribute('data-promotion-group');
      makeDecorative(copy);
      copy.querySelectorAll('.promotion__item').forEach(makeDecorative);
      track.appendChild(copy);

      const secondsPer100px = Number(root.dataset.secondsPer100px) || 2;
      root.style.setProperty('--promotion-duration', `${(group.scrollWidth / 100) * secondsPer100px}s`);
      root.dataset.promotionReady = 'true';
    };

    root.dataset.promotionInitialized = 'true';
    // ResizeObserver reports the initial size itself; rebuild only when the width really changes.
    let lastWidth = -1;
    const observer = new ResizeObserver((entries) => {
      const width = Math.round(entries[entries.length - 1].contentRect.width);
      if (width === lastWidth) return;
      lastWidth = width;
      rebuild();
    });
    observer.observe(viewport);
    root.promotionObserver = observer;
    if (document.fonts && document.fonts.status !== 'loaded') document.fonts.ready.then(rebuild);
  }

  function initWithin(context) {
    context.querySelectorAll('[data-promotion]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-promotion]').forEach((root) => root.promotionObserver?.disconnect());
  });
})();
